import { cn } from "@/lib/utils";

type LoginFooterProps = {
  termsUrl: string;
  supportUrl: string;
  className?: string;
};

const LoginFooter = ({ termsUrl, supportUrl, className }: LoginFooterProps) => {
  return (
    <div
      className={cn(
        "flex items-center justify-center gap-4 text-xs",
        className
      )}
    >
      <a
        href={termsUrl}
        target="_blank"
        rel="noreferrer noopener"
        className="text-primary-teal underline"
      >
        Terms of services
      </a>
      <div className="h-2.5 border-l border-l-neutral-200" />
      <a
        href={supportUrl}
        target="_blank"
        rel="noreferrer noopener"
        className="text-primary-teal underline"
      >
        Support
      </a>
    </div>
  );
};

export default LoginFooter;
